import { QUIZ_CATEGORIES } from "~/constants/questionnaire";
import { PRODUCTS_TO_SHOW_CHECKOUT_INSTEAD_PQP } from "~/constants/quizFunnel";

type CartLike = { slug?: string | null };

/**
 * The complete checkout-override rule: the face-cream quiz is running AND the
 * cart already holds a checkout-override product
 * (`PRODUCTS_TO_SHOW_CHECKOUT_INSTEAD_PQP`). When true, the funnel skips the
 * PQP / final quiz page and sends the user straight to checkout.
 *
 * `hasOverrideProduct` is supplied by the caller from its own cart source, so
 * the rule stays in one place: the legacy quiz reads localStorage via
 * `hasFaceCreamInCart`; the DS variants read the Zustand cart via
 * `useHasFaceCreamInCart`.
 */
export const isFaceCreamCheckoutOverride = (
    category: string,
    hasOverrideProduct: boolean
): boolean =>
    category === QUIZ_CATEGORIES.FACE_CREAM && hasOverrideProduct;

/**
 * Pure form of the checkout-override rule for the legacy quiz, which reads the
 * cart from localStorage.
 */
export const hasFaceCreamInCart = (
    category: string,
    cartItems: ReadonlyArray<CartLike>
): boolean =>
    isFaceCreamCheckoutOverride(
        category,
        cartItems.some(
            (item) =>
                !!item.slug &&
                PRODUCTS_TO_SHOW_CHECKOUT_INSTEAD_PQP.includes(item.slug)
        )
    );
